import { Fragment, useCallback, useEffect, useReducer, useState } from 'react';
import { useTranslation } from 'next-i18next';

import MetaTag from '@/components/ui/MetaTag';
import { ActionType, videoReelsQueryBuilder } from './const';
import { useFetchVideoReelsQuery } from './api';
import { initialState, reducer } from './reducer';
import toast from 'react-hot-toast';
import Post from './partials/Post';
import InfiniteScroll from 'react-infinite-scroll-component';
import { VideoReelModel } from '@/models';

const ReelListLayout = () => {
  const { t } = useTranslation('reel');

  const [{ data, filters }, dispatch] = useReducer(reducer, initialState);
  const { edges: videos, count } = data;

  const { refetch, isLoading } = useFetchVideoReelsQuery(
    videoReelsQueryBuilder(filters),
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onError: ({ message }) => {
        toast.error(message);
      },
      onSuccess: ({ data, total_records }) => {
        const edges = Array.isArray(data) ? data : [];
        dispatch({
          type: ActionType.AppendData,
          payload: { edges, count: +total_records },
        });
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [refetch, filters]);

  const handleLoadMore = useCallback(() => {
    dispatch({
      type: ActionType.OnLoadMore,
      payload: { offset: videos.length },
    });
  }, [videos]);

  const [playingVideo, setPlayingVideo] = useState<VideoReelModel | null>(null);

  const handlePlayVideo = (video: VideoReelModel) => {
    setPlayingVideo(video);
  };

  const [isStickyHeader, setIsStickyHeader] = useState(false);
  useEffect(() => {
    const header = document.getElementById('no-sticky');
    const headerHeight = header?.offsetHeight || 0;

    const scrollCallBack = () => {
      if (window.scrollY > headerHeight) {
        setIsStickyHeader(true);
      } else {
        setIsStickyHeader(false);
      }
    };
    window.addEventListener('scroll', scrollCallBack);
    return () => window.removeEventListener('scroll', scrollCallBack);
  });

  useEffect(() => {
    const index = videos.findIndex((item) => item.id === playingVideo?.id);
    if (index !== -1 && index > videos.length - 4 && videos.length < count) {
      handleLoadMore();
    }
  }, [playingVideo, videos, count, handleLoadMore]);

  return (
    <Fragment>
      <MetaTag title={t('list.title')} description={t('list.title')} />
      <div
        className={`container tw-pt-3 2xl:tw-pt-6 3xl:tw-pt-12 ${
          isStickyHeader
            ? 'tw-mt-[100px]'
            : 'md:tw-border-t tw-border-primary-main'
        }`}
      >
        {/* <InfiniteScroll
          dataLength={videos.length}
          next={handleLoadMore}
          hasMore={videos.length < count}
          loader={<></>}
          scrollThreshold={0.6}
          className="!tw-overflow-hidden"
        > */}
        <div className="!tw-overflow-hidden">
          <div className="tw-fixed sm:tw-relative tw-top-0 tw-left-0 tw-z-[1000] sm:tw-z-0 tw-h-[calc(100dvh-70px)] sm:tw-h-auto xl:tw-h-[540px] 2xl:tw-h-[650px] 3xl:tw-h-[720px] tw-w-full tw-overflow-y-scroll tw-pr-5 tw-box-content sm:tw-space-y-20 tw-snap-y tw-snap-mandatory">
            {videos.map((video) => (
              <div
                key={`post-${video.id}`}
                className="sm:tw-mb-[60px] tw-snap-center tw-snap-always"
              >
                <Post
                  video={video}
                  t={t}
                  dispatch={dispatch}
                  onPlayVideo={(video) => handlePlayVideo(video)}
                />
              </div>
            ))}
          </div>
        </div>
        {/* </InfiniteScroll> */}
      </div>
    </Fragment>
  );
};

export default ReelListLayout;
